import { renderHero } from './components/hero';
import { renderWorkspacesRail } from './components/workspacesRail';
import { renderAboutSlideshow } from './components/aboutSlideshow';
import { renderContacts } from './components/contacts';
import { renderFooter } from './components/footer';
import { renderAuthFlow } from './components/authFlow';
import { renderAuthVerify } from './components/authVerify';
import { renderEmailChangeVerify } from './components/emailChangeVerify';
import { renderBooking } from './components/booking';
import { renderAdmin } from './components/admin';
import { renderProfile } from './components/profile';
const renderers = {
    hero: renderHero,
    'workspaces-rail': renderWorkspacesRail,
    'about-slideshow': renderAboutSlideshow,
    contacts: renderContacts,
    footer: renderFooter,
    'auth-flow': renderAuthFlow,
    'auth-verify': renderAuthVerify,
    'email-change-verify': renderEmailChangeVerify,
    booking: renderBooking,
    admin: renderAdmin,
    profile: renderProfile
};
export class Renderer {
    render(root, page, templates) {
        root.innerHTML = '';
        for (const block of page.blocks) {
            if (!templates.blocks[block.type]) {
                console.warn(`No template registered for block type "${block.type}"`);
                continue;
            }
            const renderBlock = renderers[block.type];
            root.appendChild(renderBlock(block));
        }
    }
}
